import FieldErrorUi from 'common/components/core/FieldErrors/ui/FieldErrorUi'
import { CalendarStep } from 'common/components/entities/Calendar/calendar-step'
import {
  CommonCalendarButtonUi,
  CommonCalendarButtonWrapper,
} from 'common/components/entities/Calendar/calendar-step/ui/common-calendar-button-ui'
import { EventTimeZoneTypeEnum } from 'common/components/entities/Calendar/constants'
import { ThankYouStep } from 'common/components/entities/Calendar/thank-you-step'
import {
  CommonBookingCalendarContainerUi,
  CommonBookingCalendarWrapperUi,
} from 'common/components/entities/Calendar/ui/common-calendar-container-ui'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import {
  useRescheduleBooking,
  useRescheduleBookingErrors,
} from '../use-reschedule-booking'
import { RescheduleBookingCalendarUi } from './reschedule-booking-calendar-ui'

const globalFontSettings = {
  fontFamily: 'Arial, Helvetica, sans-serif',
  fontSize: 16,
  mobileFontSize: 16,
}

const entity = {
  padding: {
    paddingTop: 30,
    paddingRight: 30,
    paddingBottom: 30,
    paddingLeft: 30,
  },
  mobilePadding: {
    paddingTop: 5,
    paddingRight: 5,
    paddingBottom: 5,
    paddingLeft: 5,
  },
  margin: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
  },
  mobileMargin: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
  },

  availableSlotBackgroundColor: 'rgba(241, 244, 248, 1)',
  selectedSlotBackgroundColor: 'rgba(0, 160, 255, 1)',
  titlesColor: 'rgba(20, 45, 99, 1)',
  mobileTitlesColor: 'rgba(20, 45, 99, 1)',
  color: 'rgba(112, 112, 112, 1)',
  mobileColor: 'rgba(112, 112, 112, 1)',
}

export const RescheduleBookingCalendar = () => {
  const { t } = useTypedTranslation()

  const {
    event,
    booking,
    timeSlots,
    isEventFetching,
    isTimeSlotsFetching,
    selectedDate,
    selectedTimeZone,
    selectedTimeSlot,
    selectedLocationId,
    setSelectedDate,
    setSelectedTimeSlot,
    setSelectedLocationId,
    setSelectedTimeZone,
    onMonthSelect,

    handleRescheduleBooking,
    isLoading,
    isRescheduled,
  } = useRescheduleBooking()

  const { errors, isErrorsVisible, setIsErrorsVisible } =
    useRescheduleBookingErrors({ selectedDate, selectedTimeSlot })

  const onRescheduleBooking = () => {
    if (errors.length) {
      if (!isErrorsVisible) setIsErrorsVisible(true)
      return
    }
    handleRescheduleBooking()
  }

  return (
    <RescheduleBookingCalendarUi>
      <CommonBookingCalendarWrapperUi>
        <CommonBookingCalendarContainerUi
          isThankYouStep={isRescheduled}
          padding={entity.padding}
          margin={entity.margin}
          mobilePadding={entity.mobilePadding}
          mobileMargin={entity.mobileMargin}
          color={entity.color}
          mobileColor={entity.mobileColor}
          fontFamily={globalFontSettings.fontFamily}
          fontSize={globalFontSettings.fontSize}
          mobileFontSize={globalFontSettings.mobileFontSize}
          isDateSelected={!!selectedDate}
        >
          {isRescheduled ? (
            <ThankYouStep
              // @ts-expect-error Incorrect types
              entity={entity}
              selectedDate={selectedDate}
              selectedTimeSlot={selectedTimeSlot}
              selectedLocationId={selectedLocationId}
              selectedTimeZone={selectedTimeZone}
              event={event}
              hasThankYouStepButton={false}
              color={entity.color}
              mobileColor={entity.mobileColor}
              fontFamily={globalFontSettings.fontFamily}
              fontSize={globalFontSettings.fontSize}
              mobileFontSize={globalFontSettings.mobileFontSize}
            />
          ) : (
            <>
              <CalendarStep
                availabilitySlots={timeSlots}
                selectedDate={selectedDate}
                onMonthSelect={onMonthSelect}
                onDateSelect={date => {
                  setSelectedDate(date)
                  setSelectedTimeSlot(undefined)
                }}
                selectedTimeSlot={selectedTimeSlot}
                onTimeSlotSelect={timeSlot => setSelectedTimeSlot(timeSlot)}
                selectedTimeZone={selectedTimeZone}
                onTimeZoneSelect={tz => {
                  if (
                    event?.displayTimezoneType !== EventTimeZoneTypeEnum.Fixed
                  ) {
                    setSelectedTimeZone(tz)
                  }
                }}
                selectedLocationId={selectedLocationId}
                onLocationSelect={locationId => {
                  setSelectedLocationId(locationId)
                }}
                event={event}
                booking={booking}
                isLoading={isEventFetching || isTimeSlotsFetching}
                // @ts-expect-error Incorrect types
                entity={entity}
                color={entity.color}
                mobileColor={entity.mobileColor}
                fontFamily={globalFontSettings.fontFamily}
                fontSize={globalFontSettings.fontSize}
                mobileFontSize={globalFontSettings.mobileFontSize}
              />
              <CommonCalendarButtonWrapper>
                <CommonCalendarButtonUi
                  backgroundColor={entity.selectedSlotBackgroundColor}
                  onClick={onRescheduleBooking}
                  disabled={isLoading}
                >
                  {t('entity_settings.booking_calendar.reschedule_button_text')}
                </CommonCalendarButtonUi>
              </CommonCalendarButtonWrapper>
              {isErrorsVisible &&
                errors.map(error => (
                  <FieldErrorUi key={error}>{error}</FieldErrorUi>
                ))}
            </>
          )}
        </CommonBookingCalendarContainerUi>
      </CommonBookingCalendarWrapperUi>
    </RescheduleBookingCalendarUi>
  )
}
